import * as React from "react";
import styled, { css } from "styled-components";
import { Trans, useTranslation } from "react-i18next";
import { Explanation } from "views/components/searchbar/queryvalidation/QueryValidation";
import { Icon, IfPermitted } from "components/common";
import SelectedInternalDataLakeProvider from "data-lake/contexts/SelectedInternalDataLakeProvider";
import PreviewInternalLakeLogsButton from "data-lake/components/PreviewInternalLakeLogsButton";
import DataLakeSearchRetrieve from "./DataLakeSearchRetrieve";
const StyledIcon = styled(Icon)(
  ({ theme }) => css`
    color: ${theme.colors.variant.info};
    margin-right: ${theme.spacings.xxs};
  `
);
const DataLakePreviewLinks = ({ streams }) => {
  const { t } = useTranslation("enterprise_data_lake");
  return /* @__PURE__ */ React.createElement(React.Fragment, null, streams.map(({ stream_name: streamName, stream_id: streamId }, index) => /* @__PURE__ */ React.createElement("span", { key: streamId }, index !== 0 && /* @__PURE__ */ React.createElement("br", null), /* @__PURE__ */ React.createElement(PreviewInternalLakeLogsButton, { bsStyle: "link", streamId, bsSize: "md", target: "_blank" }, /* @__PURE__ */ React.createElement(
    Trans,
    {
      t,
      i18nKey: "query_validation.from_stream",
      values: { streamName },
      components: { stream: /* @__PURE__ */ React.createElement("i", null) }
    }
  )))));
};
const DataLakeQueryValidation = ({ validationState }) => {
  var _a, _b, _c, _d;
  const { t } = useTranslation("enterprise_data_lake");
  const hasDataLakeData = validationState.status === "INFO" && ((_a = validationState.context) == null ? void 0 : _a.data_routed_streams.length) > 0;
  if (!hasDataLakeData) {
    return null;
  }
  const streamIds = (_b = validationState.context) == null ? void 0 : _b.data_routed_streams.map((data) => data.stream_id);
  const timeRange = (_c = validationState.context) == null ? void 0 : _c.searched_time_range;
  return /* @__PURE__ */ React.createElement(SelectedInternalDataLakeProvider, null, /* @__PURE__ */ React.createElement(Explanation, null, /* @__PURE__ */ React.createElement("span", null, /* @__PURE__ */ React.createElement("p", null, /* @__PURE__ */ React.createElement(StyledIcon, { name: "database" }), " ", t("query_validation.additional_data")), /* @__PURE__ */ React.createElement("p", null, /* @__PURE__ */ React.createElement("b", null, t("query_validation.preview_logs")), /* @__PURE__ */ React.createElement("br", null), /* @__PURE__ */ React.createElement(DataLakePreviewLinks, { streams: (_d = validationState.context) == null ? void 0 : _d.data_routed_streams })), /* @__PURE__ */ React.createElement(IfPermitted, { permissions: ["data_lake_archive:restore"] }, /* @__PURE__ */ React.createElement("p", null, /* @__PURE__ */ React.createElement("b", null, t("query_validation.retrieve_logs")), /* @__PURE__ */ React.createElement("br", null), /* @__PURE__ */ React.createElement(DataLakeSearchRetrieve, { streamIds, timeRange }))))));
};
export default DataLakeQueryValidation;
